import Heading from '#/components/Heading/Heading';
import PageWrapper from '#/components/PageWrapper/PageWrapper';

import Button from '#/components/Button/Button';
import { useAppNavigation, useAppRoute } from '#/navigation/navigation.ref';
import { NewTicket } from '#/screens/support/NewTicket';
import { SingleTicket } from '#/screens/support/SingleTicket';
import { TicketList } from '#/screens/support/TicketsList';

import styles from './Support.module.scss';

export const SupportScreen = () => {
  const route = useAppRoute<'Support'>();
  const navigation = useAppNavigation();

  const isSingleTicket = !!route.params?.ticket;
  const isNewTicket = route.params?.ticket === 'new';

  return (
    <PageWrapper>
      <div className={styles.actionsHeading}>
        <Heading variant="page">Support tickets</Heading>
        {!isNewTicket && (
          <Button onPress={() => navigation.navigate('Support', { ticket: 'new' })}>
            Create new ticket
          </Button>
        )}
      </div>
      {isSingleTicket ? isNewTicket ? <NewTicket /> : <SingleTicket /> : <TicketList />}
    </PageWrapper>
  );
};
